import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledBannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  background: ${colorsPalettes.bluegrey[100]};
  border-radius: 8px;
  margin: 8px;
`;

export const StyledBannerImage = styled.img`
  width: 64px;
  height: 64px;
  flex-shrink: 0;
`;

export const StyledBannerTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  user-select: none;
`;

export const StyledBannerTitle = styled.div`
  ${setFontVariant('subtitle1', colorsPalettes.carbon[500])};
`;

export const StyledBannerSubtitle = styled.div`
  ${setFontVariant('body2', colorsPalettes.carbon[400])};
  text-align: center;
`;
